<script>
  import icons from './icons.js';
  export let name = 'dashboard';
</script>

<div class="icon">
  {@html icons[name]}
</div>

<style>:global(.icon svg){height:20px;width:20px}</style>
